<!--
  商店header
  Lovi 2020-06-19
-->
<template>
  <div class="head">
    <van-icon name="arrow-left" @click="_back" />
    <van-search
      @click="clickSearch"
      v-model="searchVal"
      shape="round"
      readonly
      :placeholder="$t('life.enterProductSearch')"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchVal: ""
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clickSearch() {
      this.$emit("update:searchFlag", true);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 10px 88px 10px;
  height: 128px;
  background-image: url("@{images}life/store/head_bg@2x.png");
  background-position: center;
  background-size: cover;
  /deep/.van-icon-arrow-left {
    font-size: 24px;
    color: #fff;
  }
  /deep/.van-search {
    flex: 1;
    margin-left: 5px;
    padding: 0;
    background: transparent;
    .van-icon {
      color: #fff;
    }
    .van-search__content {
      background: rgba(255, 255, 255, 0.32);
    }
    .van-cell {
      padding: 3px 8px 3px 0;
    }
    .van-field__control {
      color: #fff;
    }
  }
}
</style>
